import { render, staticRenderFns } from "./MitStoragePage.vue?vue&type=template&id=ca683a24&scoped=true"
import script from "./MitStoragePage.vue?vue&type=script&lang=js"
export * from "./MitStoragePage.vue?vue&type=script&lang=js"
import style0 from "./MitStoragePage.vue?vue&type=style&index=0&id=ca683a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca683a24",
  null
  
)

export default component.exports